/*
 * routingUtilityReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Lucio Chiummo
 * @since 21-Jul-2025
 */

import { produce } from 'immer'
import { actionTypes } from '../actions/routingUtilityActions'
import { nullSafe } from 'Utility/globalMethods'

const ACTION_HANDLERS = {
  [actionTypes.DO_SET_ENTRY_POINT]: produce((draft, action) => {
    const { entryPoint, section } = action.payload
    const HOME_PATH = '/'

    draft.entryPoints[section] = nullSafe(() => entryPoint, HOME_PATH)

    // const { pathname } = router.location
    // const HOME_PATH = '/'

    // if (pathname === entryPoint || pathname === HOME_PATH) {
    //   draft.entryPoints.support = entryPoint || HOME_PATH
    // }
  }),
  [actionTypes.DO_SET_CURRENT_ENTRY_POINT]: produce((draft, action) => {
    const { router } = action.payload
    const { pathname } = router.location
    draft.entryPoint = pathname
  })
  // @generator reducer:type:action
}

// The initial state of the routingUtility
const initialState = {
  entryPoints: {
    menu: '/',
    profileMenu: '/',
    support: '/',
    servicesCategories: '/',
    secondaryUsers: '/',
    comunications: '/',
    personalData: '/',
    companyData: '/',
    settings: '/',
    costs: '/',
    dispute: '/',
    disputeUci: '/'
  }
}

const routingUtility = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default routingUtility
